<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M13.735 3.467a.165.165 0 0 1 .265.129v5.591c0 .725-.588 1.313-1.313 1.313H1.313A1.313 1.313 0 0 1 0 9.187V3.598c0-.136.156-.213.265-.128.613.476 1.425 1.08 4.214 3.106.577.421 1.55 1.307 2.521 1.302.976.008 1.969-.897 2.524-1.302 2.789-2.026 3.598-2.633 4.21-3.109zM7 7c.634.01 1.548-.798 2.007-1.132 3.629-2.633 3.905-2.863 4.741-3.52A.654.654 0 0 0 14 1.833v-.52C14 .589 13.412 0 12.687 0H1.313C.588 0 0 .588 0 1.313v.519c0 .202.093.391.252.517.836.653 1.112.886 4.741 3.519C5.453 6.202 6.366 7.011 7 7z" id="5facfp273a"/>
    </defs>
    <g transform="translate(0 1.75)" fill="none" fill-rule="evenodd">
        <mask id="5w6jajjh2b" fill="currentColor">
            <use xlink:href="#5facfp273a"/>
        </mask>
        <use fill="currentcolor" fill-rule="nonzero" xlink:href="#5facfp273a"/>
        <g mask="url(#5w6jajjh2b)" fill="currentColor">
            <path d="M-3.5-5.25h21v21h-21z"/>
        </g>
    </g>
</svg>
